export enum SWeekDay {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export const SWeekDayMapping: Record<SWeekDay, string> = {
  [SWeekDay.Sunday]: 'Sunday',
  [SWeekDay.Monday]: 'Monday',
  [SWeekDay.Tuesday]: 'Tuesday',
  [SWeekDay.Wednesday]: 'Wednesday',
  [SWeekDay.Thursday]: 'Thursday',
  [SWeekDay.Friday]: 'Friday',
  [SWeekDay.Saturday]: 'Saturday'
};